import {
    CHANGE_SCRIPT_REQUEST,
    CHANGE_SCRIPT_RESULT,
    CHANGE_SCRIPT_OPEN_MODAL,
    CHANGE_SCRIPT_CLOSE_MODAL,
    CHANGE_SCRIPT_GET_DEVICE_REQUEST,
    CHANGE_SCRIPT_GET_DEVICE_RESULT,
    CHANGE_SCRIPT_SET_DEVICE,
    CHANGE_SCRIPT_GET_SCRIPTS,
    CHANGE_SCRIPT_GET_SCRIPTS_RESULTS,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    device: null,
    devices: [],
    searchDevices: null,
    scripts: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case CHANGE_SCRIPT_REQUEST:
            return { ...state, loading: true }

        case CHANGE_SCRIPT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CHANGE_SCRIPT_OPEN_MODAL:
            return { ...state, openModal: true, loading: true }

        case CHANGE_SCRIPT_CLOSE_MODAL:
            return { ...state, openModal: false }

        case CHANGE_SCRIPT_GET_DEVICE_REQUEST:
            return { ...state, loading: true }

        case CHANGE_SCRIPT_GET_DEVICE_RESULT:
            return { ...state, loading: false, searchDevices: action.payload }

        case CHANGE_SCRIPT_SET_DEVICE:
            return { ...state, devices: action.payload }

        case CHANGE_SCRIPT_GET_SCRIPTS:
            return { ...state, loading: true }

        case CHANGE_SCRIPT_GET_SCRIPTS_RESULTS:
            return { ...state, loading: false, scripts: action.payload }

        case CLEAR_REDUX:
            return ["", "CHANGE_SCRIPT"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};